<template>
  <td class="align-middle" :class="ratioBgClass">{{ displayRatio }}%</td>
</template>

<script>
export default {
  props: {
    user: { type: Object, required: true },
    customer: { type: Object, required: false, default: null }
  },
  computed: {
    displayRatio() {
      return Number(this.customer?.approved_reports_ratio ?? this.user?.approved_reports_ratio ?? 0)
    },
    ratioBgClass() {
      const ratio = this.displayRatio
      if (!ratio) return ''
      if (ratio >= 80) return 'bgCustomSuccess'
      if (ratio >= 30 && ratio < 80) return 'bgCustomWarning'
      return 'bgCustomDanger'
    }
  }
}
</script>
